import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {MatDialogRef} from "@angular/material/dialog";

export enum SeriesTabGroup {
    CONFIGURATION,
    REPORTING,
    OPERATIONS
}

export enum SeriesConfigurationTabs {
    DETAILS = 0,
    CHART = 1,
    LINKS = 2,
}

export enum SeriesOperationTabs {
    ANALYSIS = 0,
    EXCEPTIONS = 1
}

export enum SeriesReportingTabs {
    CORRECTION = 0,
    AUDIT = 1,
    SUB_AUDIT = 2
}

@Injectable({
    providedIn: 'root'
})
export class SeriesFormDialogService {
    dialogRef!: MatDialogRef<any>;
    selectedTabIndex = new BehaviorSubject<number>(0);

    currentTab: number = SeriesConfigurationTabs.DETAILS;
    tabGroup: SeriesTabGroup = SeriesTabGroup.CONFIGURATION;
    tabGroups = SeriesTabGroup;
    seriesSubTabs = {'CONFIGURATION': SeriesConfigurationTabs, 'REPORTING':SeriesReportingTabs , 'OPERATION':SeriesOperationTabs}

    constructor() {
    }

    setDialogRef(ref: MatDialogRef<any>) {
        this.dialogRef = ref;
    }

    matchTabGroup(tabGroupName: string): boolean {
        return this.tabGroup === this.tabGroups[tabGroupName];
    }

    matchTab(tabGroupName: string, tabName: string): boolean {
        return this.tabGroup === this.tabGroups[tabGroupName] && this.currentTab === this.seriesSubTabs[tabGroupName][tabName];
    }

    setTabGroup(tabGroupIndex: number): void {
        this.tabGroup = tabGroupIndex;
        this.setTab(0);
    }

    setTab(tabIndex: number): void {
        this.currentTab = tabIndex;
        this.selectedTabIndex.next(this.currentTab);
    }

    setDisabled(disabled: boolean) {
        this.dialogRef.disableClose = disabled;
    }

    closeDialog(response?) {
        if (this.dialogRef) {
            this.dialogRef.close(response);
        }
    }
}
